import { render, staticRenderFns } from "./pile-info.vue?vue&type=template&id=09b90354&"
import script from "./pile-info.vue?vue&type=script&lang=ts&"
export * from "./pile-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports